import React from 'react';

const Badge = ({ text, status }) => {
  const renderStatus = status => {
    switch (status) {
      case 'success':
        return 'bg-badge-success text-badge-success ';
      case 'default':
        return 'bg-neutral-light-50 text-neutral-dark-50';
      case 'danger':
        return 'bg-[#FFFAE6] text-[#FF8B00]';
      case 'info':
        return 'bg-blue-400 text-blue-400';
      case 'warn':
        return 'bg-yellow-400 text-yellow-400';
      default:
        return 'bg-neutral-light-50 text-neutral-dark-50 italic';
    }
  };
  return (
    <button
      className={`rounded-3xl px-5 py-1 ${renderStatus(
        status
      )}  text-center bg-opacity-20  `}
    >
      {text}
    </button>
  );
};

export default Badge;
